<template>
  <div>
    <layout-panel>
      <span slot="header">冲销审批</span>
      <el-form
        ref="form"
        :model="model"
        size="medium"
        label-width="120px"
      >
        <el-row :gutter="20" class="invoice-row">
          <el-col :span="1">序号</el-col>
          <el-col :span="2">项目编号</el-col>
          <el-col :span="3">费用承担部门</el-col>
          <el-col :span="3">一级科目</el-col>
          <el-col :span="3">二级科目</el-col>
          <el-col :span="2">发票类型</el-col>
          <el-col :span="2">税率</el-col>
          <el-col :span="2">含税冲销金额</el-col>
          <el-col :span="2">发票张数</el-col>
          <el-col :span="2">摘要</el-col>
        </el-row>
        <br />

        <el-row :gutter="20" v-for="(detailItem, itemIndex) in model.write_off_detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{itemIndex+1}}
          </el-col>
          <!-- 项目编号 -->
          <el-col key="project_id"
                  :span="2">
            <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_name"
                  :span="3">
            <span>{{detailItem.department_name}}</span>
          </el-col>

          <!--一级科目-->
          <el-col :span="3">
            <span>{{detailItem.first_subject_name}}</span>
          </el-col>
          <!--二级科目-->
          <el-col :span="3">
            <span>{{detailItem.second_subject_name}}</span>
          </el-col>
          <!--发票类型-->
          <el-col :span="2">
            <span>{{detailItem.invoice_type_name}}</span>
          </el-col>
          <!--税率-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span>
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
          </el-col>
          <!--发票张数-->
          <el-col :span="2">
            <span>{{detailItem.invoice_count}}</span>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <span style="word-break: break-all;">{{detailItem.desc}}</span>
          </el-col>
        </el-row>
        <br />
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="16">
            <p style="padding: 0; margin:0; text-align: right;">
              冲销金额合计：
            </p>
          </el-col>
          <el-col :span="2">
            ￥{{ totalWriteOffAmount | seperateThousandsToFixed(2) }}
          </el-col>
          <el-col :span="2">
            {{ totalWriteOffInvoiceCount }}
          </el-col>
        </el-row>

        <el-form-item label="核销说明："
                      prop="desc">
            <span>{{model.desc}}</span>
        </el-form-item>
        <el-form-item label="附件："
                      prop="attached_file">
          <AttachedFileContent :files="model.attached_file"/>
        </el-form-item>
        <el-form-item label="冲销日志："
                      prop="log">
            <span style="white-space:pre-wrap;">{{writeOffLogFrom(model.log)}}</span>
        </el-form-item>
        <el-form-item label="驳回原因：" prop="write_off_at">
          <el-input v-model="model.reason" placeholder="驳回时填写，通过无需填写"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(true)">审批通过</el-button>
          <el-button type="danger" @click="onSubmit(false)">审批驳回</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>


<script>

import AttachedFileContent from './AttachedFileContent'

export default {
  components: {
    AttachedFileContent
  },
  props: {
    model: {
      type: Object,
      required: true,
      default: () => {},
    },
    projectNames: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...Vuex.mapState({
      invoiceType: state => state.paymentManagerNew.invoiceType,
      taxRateType: state => state.paymentManagerNew.taxRateType,
    }),
    // 冲销金额合计
    totalWriteOffAmount () {
      return this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },

    // 发票数量合计
    totalWriteOffInvoiceCount () {
      return this.model.write_off_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
  },
  data () {
    return {
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  methods: {
    onSubmit (pass) {
      if (pass) {
        this.pass(this.model.id)
      } else {
        this.reject(this.model.id)
      }
    },
    pass (id) {
      request.common('approverPassPaymentWriteOffData', {id}).then((res) => {
        this.$alert('审核通过成功', '提示', {type: 'success'}).then(() => {
          this.$router.back()
        })
      })
    },
    reject (id) {
      if (!this.model.reason) {
        this.$message.error('请输入驳回原因')
        return
      }
      request.common('rejectPaymentWriteOffData', {id, reason: this.model.reason}).then((res) => {
        this.$alert('已驳回', '提示', {type: 'success'}).then(() => {
          this.$router.back()
        })
      })
    },
    writeOffLogFrom (logs) {
      return logs.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '')
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-manager-new/components/PaymentWriteOffReview.vue